import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import Header from "@/components/common/Header";
import FooterSection from "@/components/homepage/FooterSection";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-[#F7F5F2] font-nunito flex flex-col">
      <Header />
      
      <main className="flex-1 flex items-center justify-center py-12">
        <div className="text-center max-w-md mx-auto px-4">
          {/* 404 Illustration */}
          <div className="mb-8">
            <h1 className="text-8xl font-bold text-[#6C4F77] mb-4">404</h1>
            <div className="flex items-center justify-center mb-6">
              <img 
                src="/wabisabi-logo.png" 
                alt="Wabisabi Logo" 
                className="h-20 w-20 opacity-50" 
              />
            </div>
          </div>
          
          {/* Message */}
          <h2 className="text-2xl font-semibold text-[#6C4F77] mb-4">
            Oops! This page seems to have been forgotten
          </h2>
          <p className="text-[#2C2C2C]/80 mb-8">
            Just like memories sometimes fade, this page has wandered off. 
            Let's help you find your way back.
          </p>
          
          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button className="bg-[#6C4F77] text-white hover:bg-[#5A3A68] font-semibold">
                <Home className="h-4 w-4 mr-2" />
                Return Home
              </Button>
            </Link>
            <Button 
              variant="outline" 
              onClick={() => window.history.back()}
              className="text-[#6C4F77] border-[#6C4F77] hover:bg-[#F7F5F2] font-semibold"
            >
              <ArrowLeft className="h-4 w-4 mr-2" />
              Go Back
            </Button>
          </div>
          
          {/* Additional Help */}
          <p className="mt-8 text-sm text-[#2C2C2C]/60">
            If you believe this is an error, please{" "}
            <a href="mailto:hello@appwabisabi.com" className="text-[#6C4F77] hover:underline">
              contact us
            </a>
          </p>
        </div>
      </main>
      
      <FooterSection />
    </div>
  );
};

export default NotFound;
